import React from 'react';

const STYLES = {
  processed:   'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200',
  in_progress: 'bg-sky-100 text-sky-800 ring-1 ring-sky-200',
  queried:     'bg-rose-100 text-rose-800 ring-1 ring-rose-200',
  pending:     'bg-amber-100 text-amber-800 ring-1 ring-amber-200',
};

const LABELS = {
  processed: 'Processed',
  in_progress: 'In Progress',
  queried: 'Queried',
  pending: 'Pending',
};

export default function StatusPill({ status, size = 'md' }) {
  const cls = STYLES[status] || STYLES.pending;
  const sizing = size === 'sm' ? 'px-1.5 py-0.5 text-[13px]' : 'px-2 py-0.5 text-[14px]';
  return (
    <span className={`inline-flex items-center rounded font-semibold tracking-wide ${sizing} ${cls}`}>
      {LABELS[status] || 'Pending'}
    </span>
  );
}
